import styled, { css } from "styled-components"
import { Button } from "../.."

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
`

export const PagPrevNextBtn = styled(Button)`
  width: 100px;
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};

  display: flex;
  align-items: center;
  gap: 3px;
`

export const PagNumberBtn = styled(Button)`
  display: grid;
  width: 40px;
  color: ${({ theme }) => theme.old.colors.gray[450]};
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};

  ${({ $isActive }) => $isActive && css`
    color: ${({ theme }) => theme.old.colors.white};
    background-color: ${({ theme }) => theme.old.colors.primary};
    
    :hover {
      color: ${({ theme }) => theme.old.colors.white};
      background-color: ${({ theme }) => theme.old.colors.primary};
    }

    :active {
      color: ${({ theme }) => theme.old.colors.white};
      background-color: ${({ theme }) => theme.old.colors.primary};
    }
  `}
`